import cx from 'classnames';
import PropTypes from 'prop-types';
import { useFocused, useSelected } from 'slate-react';

import { CustomTooltip } from 'src/components/CustomTooltip';
import { VariableTooltip } from 'src/components/VariableTooltip';

import { VoidNodeContent } from '../VoidNodeContent';

import { useStyles } from './useStyles';

export const VariableNode = ({ element, children, attributes }) => {
  const styles = useStyles();

  const selected = useSelected();
  const focused = useFocused();

  return (
    <CustomTooltip title={getTooltipTitle(element)}>
      <span
        className={cx(styles.root, {
          [styles.highlighted]: selected && focused,
        })}
        {...attributes}
        contentEditable={false}
      >
        <VoidNodeContent
          className={styles.content}
          text={element.children[0].text}
        >
          {children}
        </VoidNodeContent>
      </span>
    </CustomTooltip>
  );
};

VariableNode.propTypes = {
  attributes: PropTypes.shape({}),
  element: PropTypes.shape().isRequired,
  children: PropTypes.node,
};

VariableNode.defaultProps = {
  attributes: {},
  children: null,
};

const getTooltipTitle = (element) => {
  const textTooltip =
    element.children[0].infoTooltip || element.children[0].info || element.infoTooltip;
  if (textTooltip) {
    return textTooltip;
  }

  const { tooltipTitle, tooltipDescription } = element;
  if (tooltipDescription) {
    return (
      <VariableTooltip
        title={tooltipTitle}
        description={tooltipDescription}
      />
    );
  }

  return '';
};
